import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import ResourceDialogForm from "./_ResourceDialogForm";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import { notifySomething } from "../_Utils/AppDocuCommon";

export default class EditResourceDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevItemId: null,
    };
  }

  async componentDidMount() {
    if (this.props.itemId) {
      await this.loadItem(this.props.itemId);
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.itemId && this.props.itemId !== prevProps.itemId) {
      await this.loadItem(this.props.itemId);
    }
    if (!this.props.itemId && prevProps.itemId) {
      this.setState({ itemData: null, loading: false, prevItemId: null });
    }
  }

  loadItem = async (id) => {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.getResource(id);
      const doc = res.data.resource || res.data.document || {};
      await new Promise(resolve => setTimeout(resolve, 500));
      this.setState({ itemData: doc, loading: false, prevItemId: id });
    } catch (e) {
      this.setState({ loading: false });
      notifySomething('Error loading resource data', 'error');
    }
  };

  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      folder: m.folder ?? '',
      name: m.name ?? '',
      description: m.description ?? '',
      language: m.language ?? '',
      original_filename: m.original_filename ?? '',
      com_brand: m.com_brand ?? '',
      first_page: m.first_page ? 1 : 0,
    };
    try {
      const res = await AppDocuServiceCall.updateResource(data);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating resource', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating resource:', error);
      notifySomething('Error updating resource', 'error');
    }
  };

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
        {loading || !itemData ? (
          <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Resource</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
                <CircularProgress size={40} thickness={4} />
              </div>
            </DialogContent>
          </Dialog>
        ) : (
          <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Resource</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
              <ResourceDialogForm
                itemData={itemData}
                onChange={newData => this.setState({ itemData: newData })}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.props.onClose}>Cancel</Button>
              <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  }
}
